import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('./libs/connect.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.03}>
        <primitive object={nodes.pm0133_00} />
        <skinnedMesh
          geometry={nodes.Eevee_1.geometry}
          material={materials.Material__12}
          skeleton={nodes.Eevee_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Eevee_2.geometry}
          material={materials.Material__13}
          skeleton={nodes.Eevee_2.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Eevee_3.geometry}
          material={materials.Material__14}
          skeleton={nodes.Eevee_3.skeleton}
        />
      </group>
      <group position={[1.42, 0, 0]} rotation={[0, -0.57, 0]} scale={0.01}>
        <primitive object={nodes.pm0134_00} />
        <skinnedMesh
          geometry={nodes.Vaporeon_1.geometry}
          material={materials.Material__10}
          skeleton={nodes.Vaporeon_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Vaporeon_2.geometry}
          material={materials.Material__11}
          skeleton={nodes.Vaporeon_2.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Vaporeon_3.geometry}
          material={materials['Material__12.001']}
          skeleton={nodes.Vaporeon_3.skeleton}
        />
      </group>
      <group position={[-1.03, 0, 0]} rotation={[0, 0.36, 0]} scale={0.01}>
        <primitive object={nodes.pm0135_00} />
        <skinnedMesh
          geometry={nodes.Jolteon_1.geometry}
          material={materials['Material__10.001']}
          skeleton={nodes.Jolteon_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Jolteon_2.geometry}
          material={materials['Material__11.001']}
          skeleton={nodes.Jolteon_2.skeleton}
        />
      </group>
      <group position={[2.34, 0, 0]} rotation={[0, -0.64, 0]} scale={0.01}>
        <primitive object={nodes.pm0136_00} />
        <skinnedMesh
          geometry={nodes.Flareon_1.geometry}
          material={materials['Material__10.002']}
          skeleton={nodes.Flareon_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Flareon_2.geometry}
          material={materials['Material__11.002']}
          skeleton={nodes.Flareon_2.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Flareon_3.geometry}
          material={materials['Material__12.002']}
          skeleton={nodes.Flareon_3.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Flareon_4.geometry}
          material={materials['Material__13.001']}
          skeleton={nodes.Flareon_4.skeleton}
        />
      </group>
      <group position={[-1.96, 0, 0]} rotation={[0, 0.56, 0]} scale={0.01}>
        <primitive object={nodes.pm0196_00} />
        <skinnedMesh
          geometry={nodes.Espeon_1.geometry}
          material={materials.Material__105}
          skeleton={nodes.Espeon_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Espeon_2.geometry}
          material={materials.Material__106}
          skeleton={nodes.Espeon_2.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Espeon_3.geometry}
          material={materials.Material__107}
          skeleton={nodes.Espeon_3.skeleton}
        />
      </group>
    </group>
  )
}

useGLTF.preload('./libs/connect.glb')
